<template>
	<div>
		<div
			class="user-preview-card__wrapper d-flex align-center mb-2"
			v-bind:style="{ paddingTop: userFlag ? '32px' : '16px' }"
		>
			<ProfileBadge v-if="userFlag" :badge="userFlag" />

			<Avatar class="mr-8 post-preview-card__avatar" ize="85" :avatar="logo" />

			<div class="user-preview-card__users_box">
				<div v-if="name" class="user-preview-card__title mb-2">
					{{ name }}
				</div>
				<div v-if="secondRow" class="user-preview-card__description mb-2">
					{{ secondRow }}
				</div>
				<div v-if="thirdRow" class="user-preview-card__description mb-2">
					{{ thirdRow }}
				</div>
				<div v-if="location" class="user-preview-card__location mb-2 d-flex align-center">
					<Icon type="pin" color="var(--location-color)" :size="24" :pr="4" />
					{{ location }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Avatar from '@/components/Avatar'
import ProfileBadge from '@/components/ProfileBadge.vue'

Vue.use(VueScrollTo)

export default {
	name: 'AttendCard',

	components: {
		Avatar,
		ProfileBadge,
	},
	props: {
		user: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		userFlag() {
			const { userFlag: flag } = this.user || {}

			return flag
		},
		logo() {
			const { user_logo: logo } = this.user || {}

			return logo
		},
		name() {
			const { visible_username: name } = this.user || {}

			return name
		},
		location() {
			const { location_profile_row: location } = this.user || {}

			return location
		},
		secondRow() {
			const { second_profile_row: row } = this.user || {}

			return row
		},
		thirdRow() {
			const { third_profile_row: row } = this.user || {}

			return row
		},
	},
}
</script>

<style lang="scss">
.user-preview-card {
	&__wrapper {
		display: flex;
		background: #ffffff;
		border-radius: 10px;
		padding: 16px;
		position: relative;
	}

	&__logo {
		width: 25%;
		object-fit: contain;
		margin-right: 10px;
	}

	&__title {
		color: var(--username-category-title);
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		word-break: break-word;
	}

	&__location {
		display: flex;
		color: var(--location-color);
		font-size: 13px;
		font-family: Montserrat, sans-serif;
		font-weight: 600;
		letter-spacing: 0;
		line-height: 17px;
		word-break: break-word;
	}

	&__description {
		color: var(--company-position-large);
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		line-height: 20px;
		word-break: break-word;
	}

	&__user-flag {
		text-align: right;
		position: absolute;
		border-radius: 12px;
		top: 0;
		right: 0;

		span {
			z-index: 0;
			position: relative;
			background: var(--accent-color);
			display: inline-flex;
			padding: 5px 10px 5px 10px;
			border-top-right-radius: 8px;
			color: rgb(255, 255, 255);
			font-size: 12px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
		}

		// Start
		span {
			span {
				z-index: -1;
				content: '';
				position: absolute;
				left: -17%;
				top: 0;
				height: 100%;
				width: 100%;
				-webkit-transform: skewX(20deg);
				-moz-transform: skewX(20deg);
				-ms-transform: skewX(20deg);
				transform: skewX(20deg);
			}
		}
	}
}

@media screen and (min-width: 1200px) {
	.user-preview-card__wrapper {
		max-width: 100%;
		width: 100%;
	}
}

@media screen and (min-width: 1320px) {
	.user-preview-card__wrapper {
		max-width: 600px;
	}
}
</style>
